import { z } from "zod";
import { fetchApiPost } from "../../utils";
import { PossibleReturnType } from "../../../responseResults";

const PresignUploadValidation = z.object({
  filename: z.string().min(1),
  content_type: z.string().optional(),
});

const SplicingValidation = z.object({
  document_id: z.string().uuid(),
});

export interface PresignUploadResponse {
  document_id: string;
  presigned_put_url: string;
}

export interface SplicingResponse {
  key: string;
  bucket: string;
  region: string;
  presigned_get_url: string;
}

export async function presignUpload(
  data: z.infer<typeof PresignUploadValidation>
): Promise<PossibleReturnType<PresignUploadResponse>> {
  return fetchApiPost<PresignUploadResponse>(
    "video/hedgebeacon/upload/presign",
    PresignUploadValidation.parse(data)
  );
}

export async function splicing(
  data: z.infer<typeof SplicingValidation>
): Promise<PossibleReturnType<SplicingResponse>> {
  return fetchApiPost<SplicingResponse>(
    "video/hedgebeacon/splicing",
    SplicingValidation.parse(data)
  );
}

